import { AsyncDirective } from 'lit/async-directive.js';
import { directive } from 'lit/directive.js';
import { asapScheduler, observeOn } from 'rxjs';
class ObserveDirective extends AsyncDirective {
    render(observable, initValue) {
        if (this.subscription) {
            return this.lastValue ?? initValue ?? '';
        }
        this.subscription = observable.pipe(observeOn(asapScheduler)).subscribe((value) => {
            this.lastValue = value;
            this.setValue(value);
        });
        return initValue ?? '';
    }
    disconnected() {
        this.subscription?.unsubscribe();
    }
}
export const observe = directive(ObserveDirective);
//# sourceMappingURL=observe-directive.js.map